/** @format */

import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { FaLongArrowAltUp } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import Slider from "react-slick";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import Details from "../Details/Details.component";
import { ImageConverter } from "./idxhelperfunctions";
import {
  ComparableHomes,
  Container,
  Content,
  ImageNotFoundContainer,
  LoadingContainer,
  Nav,
  NavContainer,
  Contact,
} from "./idxView.style";
import moment from "moment";
// import PropertyCard from '../../Template2/components/PropertyCard/PropertyCard.t2';

//images
import ImageNotFound from "../../../images/image-not-found-icon.svg";
import ConvertToCanadianNumber from "../../../utils/New_construction_details/ConvertNumberToDollar.util";
import PropertyCard, {
  PROPERTY_TYPE_CLASSES,
} from "../PropertyCard/PropertyCard.utilComponent";
import { TimeLabel } from "../../../utils/New_construction_details/timelabel";
import AppointmentForm from "../Details/Components/appointment/Appointment.component";
import { AppointmentContainer } from "../Details/Details.style";
import SoldProperty from "../SoldProperty/SoldProperty.utilComponents";
import PropertyCard1 from "../PropertyCard1/PropertyCard1.utilComponent";
import Cookies from "js-cookie";
import usePermissionSoldProperty from "../../CustomHooks/usePermissionSoldProperty.customHook";
import SoldHomeForm from "../SoldHomeForm/SoldHomeForm.component";
import { Helmet } from "react-helmet-async";
type PropertyProps = {
  cardType?: PROPERTY_TYPE_CLASSES;
};
type ProfileProps = {
  _id: string;
  name: string;
  brokeragename: string,
  phone: string;
  description: string;
  email: string;
  image: string;
};
export default function PropertyView({ cardType }: PropertyProps) {
  const { propertyId, type, mls } = useParams();
  const [propertyid, setPropertyId] = useState(propertyId);
  const [Data, setData] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loader, setLoader] = useState("loading");
  const [ScrollValue, setScrollValue] = useState(0);
  const sliderRef = useRef(null);
  const FeaturedslideRef = useRef(null);
  const viewerRef = useRef(null);
  const [renderViewer, setRenderViewer] = useState(false);
  const [soldProperty, setSoldProperty] = useState(null);
  const [similarProperty, setSimilarProperty] = useState([]);
  const openGallery = () => {
    setRenderViewer(!renderViewer);
  };
  const [appointment, setAppointment] = useState(false);
  const handleScrollUp = () => {
    window.scrollTo(0, 0);
  };
  const token = Cookies.get("token");

  const [profile, setProfile] = useState<ProfileProps>({
    _id: "",
    name: "",
    brokeragename: "",
    phone: "",
    description: "",
    email: "",
    image: "",
  });
  const handleScroll = () => {
    setScrollValue(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    handleScrollUp();
  }, []);
  useEffect(() => {
    const fetchProfile = async (): Promise<void> => {
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };
      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }
      try {
        const profileData = await axios.get("/api/get-agent-profile", config);
        setProfile(profileData.data.data);

      } catch (e) {
        throw new Error(e);
      }
    };
    fetchProfile();
  }, []);
  useEffect(() => {
    let viewer;
    if (renderViewer && viewerRef.current) {
      viewer = new Viewer(viewerRef.current, {
        hidden() {
          setRenderViewer(false);
        },
      });
      viewer.view();
    }
    return () => {
      if (viewer) {
        viewer.destroy();
      }
    };
  }, [renderViewer]);
  useEffect(() => {
    const FetchData = async () => {
      setLoader("loading");
      const apiUrl =
        type === "sold"
          ? `https://api.bluebrickglobal.com/api/sold/property/${propertyId}`
          : `https://api.bluebrickglobal.com/api/get-idx-property/${propertyId}`;
      try {
        const fetchData = await axios.get(apiUrl);
        const respData = fetchData.data;
        if (type === "sold") {
          const soldData = respData.data ?? respData;
          setData(Array.isArray(soldData) ? soldData[0] : soldData);
        } else {
          const idxData = respData.data ?? respData;
          setData(Array.isArray(idxData) ? idxData[0] : idxData);
        }
        setLoader("complete");
      } catch (err) {
        throw new Error(err);
      }
    };
    FetchData();
    handleScrollUp();
  }, [propertyId]);
  const SoldInDays = (listedDay, soldDay): number => {
    if (!listedDay || !soldDay) {
      return null;
    }
    let start = moment(listedDay);
    let end = moment(soldDay);

    return end.diff(start, "days");
  };
  useEffect(() => {
    const FetchData = async () => {
      if (type === "idx") {
        try {
          const fetchData = await axios.get(`
          https://valuation.santhoshmathew.com/api/v1/properties/related/sold/${propertyId}`);
          const Data = await fetchData.data;
          setSoldProperty(
            Data.data.map((item) => ({
              id: item.id,
              // img: `https://s3.us-west-1.wasabisys.com/redbuyers-main/${item.photos[0].url}`,
              // img:item.photos,
              img: ImageConverter(item.photos, "sold"),
              price: ConvertToCanadianNumber(item.sold_price),
              title: `${item.address} ${item.county} ${item.zip_code}`,
              text: item.realtor,
              bedrooms:
                item?.bedrooms === null
                  ? 0
                  : Number(item?.bedrooms) > Number(item?.additional_bathroom)
                    ? Number(item?.bedrooms) - Number(item?.additional_bathroom)
                    : item?.bedrooms,
              bathrooms: item.bathrooms,
              garage: item.garage,
              listed_price: ConvertToCanadianNumber(
                item.property_details?.["Lp_dol"],
              ),
              sold_on: item?.sold_date?.split(" ")?.[0],
              sold_in: SoldInDays(
                item?.property_details?.Input_date,
                item?.property_details?.Unavail_dt,
              ),
              sale_or_lease: "sold",
              redirect: `../../../soldlisting/sold/soldview`,
            })),
          );
        } catch (err) {
          throw new Error(err);
        }
      }
    };
    FetchData();
  }, [propertyId]);

  useEffect(() => {
    const FetchData = async () => {
      const apiUrl =
        type === "sold"
          ? `https://api.bluebrickglobal.com/api/sold-filter?page=1&sortDir=desc`
          : `https://api.bluebrickglobal.com/api/get-idx-similar/${propertyId}`;
      try {
        const fetchData = await axios.get(apiUrl);
        const raw = fetchData.data;

        if (type === "sold") {
          const items = raw?.properties ?? raw?.data ?? [];
          setSimilarProperty(
            items.map((item) => ({
              id: item.propertyId,
              img: [...(item.photos ?? [])].sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0)).map((p: any) => p?.url ?? p),
              price: ConvertToCanadianNumber(item.solPrice),
              title: `${item.address} ${item.city}`,
              bedrooms: item.bedroomsTotal,
              bathrooms: item.bathroomsTotal,
              garage: item.garageSpaces,
              sale_or_lease: "sold",
              listed_price: ConvertToCanadianNumber(item.listPrice),
              sold_on: item?.closeDate?.split("T")?.[0],
              sold_in: SoldInDays(item?.listingContractDate, item?.unavailableDate),
              redirect: `../sold/soldview`,
            })),
          );
        } else {
          console.log('get-idx-similar raw:', raw);
          const items = Array.isArray(raw) ? raw
            : Array.isArray(raw?.data) ? raw.data
            : Array.isArray(raw?.properties) ? raw.properties
            : Array.isArray(raw?.listings) ? raw.listings
            : [];
          setSimilarProperty(
            items.map((item) => ({
              id: item.propertyId,
              img: [...(item.photos ?? [])].sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0)).map((p: any) => p?.url ?? p),
              price: ConvertToCanadianNumber(item.listPrice),
              title: `${item.address ?? ""}, ${item.cityRegion ?? item.city ?? ""}`,
              bedrooms: item.bedroomsTotal ?? 0,
              bathrooms: item.bathroomsTotal ?? 0,
              garage: item.garageSpaces ?? 0,
              sale_or_lease: item.transactionType,
              city: item.city,
              redirect: `../idxView`,
            })),
          );
        }
      } catch (err) {
        console.error("Similar properties error:", err);
      }
    };
    FetchData();
  }, [propertyId]);
  const formatDollars = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  const CustomPrevArrow = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className="prev"
      {...props}
    >
      <g clip-path="url(#clip0_491_452)" filter="url(#filter0_b_491_452)">
        <g filter="url(#filter1_b_491_452)">
          <path
            // fill-rule="evenodd"
            // clip-rule="evenodd"
            d="M20 0C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10C0 4.47715 4.47715 0 10 0H20ZM15.7482 29.0747C15.7439 29.0725 15.7388 29.0729 15.7341 29.0738C15.7297 29.0746 15.7255 29.076 15.7215 29.0779L15.6468 29.1148C15.6414 29.1174 15.6358 29.1193 15.63 29.1205L15.6268 29.1211C15.6182 29.1229 15.6094 29.1225 15.601 29.1201C15.5978 29.1192 15.5948 29.118 15.5918 29.1166L15.5075 29.075C15.4977 29.0711 15.4887 29.0725 15.4823 29.0769C15.4787 29.0793 15.4767 29.0833 15.4751 29.0872C15.4734 29.0915 15.4724 29.0961 15.4722 29.1008L15.4517 29.6183C15.4514 29.6252 15.4521 29.6322 15.4538 29.6389L15.4546 29.6422C15.4565 29.6498 15.46 29.657 15.4648 29.6632C15.4682 29.6677 15.4724 29.6717 15.477 29.675L15.594 29.7583C15.598 29.7611 15.6024 29.7631 15.6071 29.7644L15.6086 29.7648C15.6152 29.7666 15.6222 29.7663 15.6288 29.7642C15.6321 29.7631 15.6352 29.7615 15.638 29.7594L15.7551 29.6762C15.7608 29.6721 15.7659 29.6671 15.7702 29.6615L15.7708 29.6606C15.776 29.6536 15.7798 29.6456 15.7818 29.6371C15.7831 29.6316 15.7836 29.6259 15.7834 29.6201L15.7629 29.1062C15.7626 29.0987 15.7624 29.091 15.7585 29.0846C15.7559 29.0802 15.7523 29.0767 15.7482 29.0747ZM16.0806 28.9342C16.0756 28.9314 16.0696 28.9317 16.0639 28.9326C16.0588 28.9334 16.0539 28.9349 16.0493 28.9372L15.831 29.047C15.827 29.049 15.8234 29.0516 15.8203 29.0547L15.8189 29.0561C15.8147 29.0603 15.8117 29.0655 15.8101 29.0712C15.8092 29.0745 15.8088 29.078 15.809 29.0815L15.831 29.6067C15.8312 29.6114 15.8322 29.616 15.834 29.6203L15.8343 29.6212C15.8364 29.6262 15.8396 29.6306 15.8437 29.6342C15.8462 29.6364 15.8491 29.6382 15.8521 29.6396L16.0987 29.7537C16.1099 29.7575 16.1204 29.7556 16.1282 29.7503C16.1333 29.7467 16.1359 29.7406 16.1376 29.7346C16.1392 29.7291 16.1398 29.7233 16.1395 29.7176L16.0983 28.9725C16.0978 28.9634 16.0971 28.9539 16.0924 28.946C16.0894 28.9408 16.0854 28.9368 16.0806 28.9342ZM15.1787 28.9338C15.1731 28.9312 15.1667 28.9305 15.1606 28.9319C15.1574 28.9326 15.1544 28.9338 15.1517 28.9355C15.1467 28.9386 15.1438 28.944 15.1415 28.9494C15.1389 28.9556 15.1373 28.9622 15.1369 28.969L15.095 29.7262C15.095 29.7366 15.0992 29.7446 15.1059 29.7502C15.112 29.7552 15.1203 29.7557 15.1281 29.7547C15.1327 29.7541 15.1371 29.7528 15.1413 29.7508L15.3819 29.6395C15.3848 29.6382 15.3875 29.6365 15.39 29.6345L15.3914 29.6334C15.3962 29.6295 15.3999 29.6244 15.402 29.6187C15.4031 29.6154 15.4038 29.612 15.404 29.6085L15.4248 29.0815C15.4249 29.078 15.4246 29.0745 15.4237 29.0711C15.4221 29.0647 15.4188 29.0588 15.414 29.054L15.4134 29.0534C15.4103 29.0503 15.4068 29.0478 15.4029 29.0458L15.1787 28.9338Z"
            fill="#2C3647"
            fill-opacity="0.9"
            id="card_overlay"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.366 15.8834C10.1316 15.649 10 15.3312 10 14.9997C10 14.6682 10.1316 14.3504 10.366 14.1159L17.4372 7.0447C17.5525 6.92531 17.6905 6.83008 17.843 6.76457C17.9955 6.69906 18.1595 6.66458 18.3255 6.66313C18.4915 6.66169 18.6561 6.69332 18.8097 6.75617C18.9633 6.81902 19.1029 6.91184 19.2202 7.0292C19.3376 7.14657 19.4304 7.28613 19.4933 7.43975C19.5561 7.59337 19.5877 7.75797 19.5863 7.92395C19.5849 8.08992 19.5504 8.25395 19.4849 8.40645C19.4193 8.55896 19.3241 8.69689 19.2047 8.8122L13.0172 14.9997L19.2047 21.1872C19.4324 21.423 19.5584 21.7387 19.5556 22.0664C19.5527 22.3942 19.4213 22.7077 19.1895 22.9395C18.9577 23.1712 18.6442 23.3027 18.3165 23.3055C17.9887 23.3084 17.673 23.1824 17.4372 22.9547L10.366 15.8834Z"
          fill="#FDFDFE"
          id="card-arrows"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_491_452"
          x="-2"
          y="-2"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_491_452"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_491_452"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_491_452"
          x="-10"
          y="-10"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_491_452"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_491_452"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_491_452">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const CustomNextArrow = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className="next"
      {...props}
    >
      <g clip-path="url(#clip0_491_456)" filter="url(#filter0_b_491_456)">
        <g filter="url(#filter1_b_491_456)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 0C25.5228 0 30 4.47715 30 10V20C30 25.5228 25.5228 30 20 30H10C4.47715 30 0 25.5228 0 20V10C0 4.47715 4.47715 0 10 0H20ZM15.7482 29.0747C15.7439 29.0725 15.7388 29.0729 15.7341 29.0738C15.7297 29.0746 15.7255 29.076 15.7215 29.0779L15.6468 29.1148C15.6414 29.1174 15.6358 29.1193 15.63 29.1205L15.6268 29.1211C15.6182 29.1229 15.6094 29.1225 15.601 29.1201C15.5978 29.1192 15.5948 29.118 15.5918 29.1166L15.5075 29.075C15.4977 29.0711 15.4887 29.0725 15.4823 29.0769C15.4787 29.0793 15.4767 29.0833 15.4751 29.0872C15.4734 29.0915 15.4724 29.0961 15.4722 29.1008L15.4517 29.6183C15.4514 29.6252 15.4521 29.6322 15.4538 29.6389L15.4546 29.6422C15.4565 29.6498 15.46 29.657 15.4648 29.6632C15.4682 29.6677 15.4724 29.6717 15.477 29.675L15.594 29.7583C15.598 29.7611 15.6024 29.7631 15.6071 29.7644L15.6086 29.7648C15.6152 29.7666 15.6222 29.7663 15.6288 29.7642C15.6321 29.7631 15.6352 29.7615 15.638 29.7594L15.7551 29.6762C15.7608 29.6721 15.7659 29.6671 15.7702 29.6615L15.7708 29.6606C15.776 29.6536 15.7798 29.6456 15.7818 29.6371C15.7831 29.6316 15.7836 29.6259 15.7834 29.6201L15.7629 29.1062C15.7626 29.0987 15.7624 29.091 15.7585 29.0846C15.7559 29.0802 15.7523 29.0767 15.7482 29.0747ZM16.0806 28.9342C16.0756 28.9314 16.0696 28.9317 16.0639 28.9326C16.0588 28.9334 16.0539 28.9349 16.0493 28.9372L15.831 29.047C15.827 29.049 15.8234 29.0516 15.8203 29.0547L15.8189 29.0561C15.8147 29.0603 15.8117 29.0655 15.8101 29.0712C15.8092 29.0745 15.8088 29.078 15.809 29.0815L15.831 29.6067C15.8312 29.6114 15.8322 29.616 15.834 29.6203L15.8343 29.6212C15.8364 29.6262 15.8396 29.6306 15.8437 29.6342C15.8462 29.6364 15.8491 29.6382 15.8521 29.6396L16.0987 29.7537C16.1099 29.7575 16.1204 29.7556 16.1282 29.7503C16.1333 29.7467 16.1359 29.7406 16.1376 29.7346C16.1392 29.7291 16.1398 29.7233 16.1395 29.7176L16.0983 28.9725C16.0978 28.9634 16.0971 28.9539 16.0924 28.946C16.0894 28.9408 16.0854 28.9368 16.0806 28.9342ZM15.1787 28.9338C15.1731 28.9312 15.1667 28.9305 15.1606 28.9319C15.1574 28.9326 15.1544 28.9338 15.1517 28.9355C15.1467 28.9386 15.1438 28.944 15.1415 28.9494C15.1389 28.9556 15.1373 28.9622 15.1369 28.969L15.095 29.7262C15.095 29.7366 15.0992 29.7446 15.1059 29.7502C15.112 29.7552 15.1203 29.7557 15.1281 29.7547C15.1327 29.7541 15.1371 29.7528 15.1413 29.7508L15.3819 29.6395C15.3848 29.6382 15.3875 29.6365 15.39 29.6345L15.3914 29.6334C15.3962 29.6295 15.3999 29.6244 15.402 29.6187C15.4031 29.6154 15.4038 29.612 15.404 29.6085L15.4248 29.0815C15.4249 29.078 15.4246 29.0745 15.4237 29.0711C15.4221 29.0647 15.4188 29.0588 15.414 29.054L15.4134 29.0534C15.4103 29.0503 15.4068 29.0478 15.4029 29.0458L15.1787 28.9338Z"
            fill="#2C3647"
            fill-opacity="0.9"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.6344 14.1165C19.8688 14.3509 20.0004 14.6688 20.0004 15.0002C20.0004 15.3317 19.8688 15.6496 19.6344 15.884L12.5632 22.9552C12.4479 23.0746 12.3099 23.1698 12.1574 23.2354C12.0049 23.3009 11.8409 23.3353 11.6749 23.3368C11.509 23.3382 11.3444 23.3066 11.1907 23.2438C11.0371 23.1809 10.8975 23.0881 10.7802 22.9707C10.6628 22.8534 10.57 22.7138 10.5071 22.5602C10.4443 22.4065 10.4127 22.2419 10.4141 22.076C10.4156 21.91 10.45 21.746 10.5155 21.5935C10.5811 21.441 10.6763 21.303 10.7957 21.1877L16.9832 15.0002L10.7957 8.81273C10.568 8.57697 10.442 8.26122 10.4448 7.93347C10.4477 7.60573 10.5791 7.29221 10.8109 7.06045C11.0427 6.82869 11.3562 6.69723 11.6839 6.69438C12.0117 6.69154 12.3274 6.81753 12.5632 7.04523L19.6344 14.1165Z"
          fill="#FDFDFE"
          id="card-arrows"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_491_456"
          x="-2"
          y="-2"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_491_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_491_456"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_491_456"
          x="-10"
          y="-10"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_491_456"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_491_456"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_491_456">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  const handlePrevious = (ref) => {
    ref.current.slickPrev();
  };

  const handleNext = (ref) => {
    ref.current.slickNext();
  };

  const PropertyDetails = {
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    prevArrow: <CustomPrevArrow onClick={() => handlePrevious(sliderRef)} />,
    nextArrow: <CustomNextArrow onClick={() => handleNext(sliderRef)} />,
  };

  const FeaturedCard = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: (
      <CustomPrevArrow onClick={() => handlePrevious(FeaturedslideRef)} />
    ),
    nextArrow: <CustomNextArrow onClick={() => handleNext(FeaturedslideRef)} />,
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 730,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const {
    user,
    open,
    handleOpenClose,
    handleNavigation,
    handleSubmitForm,
    handleState,
  } = usePermissionSoldProperty();


  return (

    <>
      <Helmet>
        {/* Twitter Card Metadata */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${Data?.address},${Data?.city}`} />
        <meta name="twitter:description" content={Data?.property_description} />
        <meta name="twitter:image" content={
          type === "sold"
            ? `https://s3.us-west-1.wasabisys.com/redbuyers-main/${Data?.photos?.[0]?.url}`
            : Data?.photos?.[0]?.url ?? Data?.photos?.[0]
        } />

        {/* Open Graph Metadata */}
        <meta property="og:title" content={`${Data?.address},${Data?.city}`} />
        <meta property="og:description" content={`${Data?.address},${Data?.city}`} />
        <meta property="og:image" content={
          type === "sold"
            ? `https://s3.us-west-1.wasabisys.com/redbuyers-main/${Data?.photos?.[0]?.url}`
            : Data?.photos?.[0]?.url ?? Data?.photos?.[0]
        } />
      </Helmet>
      {loader === "loading" ? (
        <LoadingContainer>
          <div className="loader"></div>
        </LoadingContainer>
      ) : (
        <div>
          <Container ScrollValue={ScrollValue}>
            <div className="Slider mb-4">
              {type === "sold" && (
                <div className="Sold_logo">
                  <p>SOLD</p>
                </div>
              )}
              <Slider {...PropertyDetails} ref={sliderRef}>
                {Data?.photos?.length ? (
                  [...Data.photos]
                    .sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0))
                    .map((data: any) => {
                      const src = type === "sold"
                        ? `https://s3.us-west-1.wasabisys.com/redbuyers-main/${data?.url}`
                        : (data?.url ?? data);
                      return <img key={src} src={src} alt="HomeCovers" />;
                    })
                ) : (
                  <ImageNotFoundContainer>
                    <img className="svg_box" src={ImageNotFound} alt="imageNotFound" />
                  </ImageNotFoundContainer>
                )}
              </Slider>
              <div className="slider_button" onClick={openGallery}>
                <p>+ show all {Data?.photos?.length} photos</p>
              </div>
            </div>

            <div className="no_slider" ref={viewerRef}>
              {[...(Data?.photos ?? [])]
                .sort((a: any, b: any) => (a.imageOrder ?? 0) - (b.imageOrder ?? 0))
                .map((data: any) => {
                  const src = data?.url ?? data;
                  return <img key={src} src={src} alt="HomeCovers" />;
                })}
            </div>
            <Nav>
              <Link to="../../home">Home &gt; </Link>
              <Link to="../../idxlisting">Properties &gt; </Link>
              <p>{`${Data?.address},${Data?.city}`}</p>
            </Nav>
            <div className="ScrollUpArrow" onClick={handleScrollUp}>
              <FaLongArrowAltUp style={{ color: "white" }} />
            </div>
            <h1 className="cusfonth">
              {Data?.address === null
                ? "No Data"
                : `${Data?.address},${Data?.city}`}
            </h1>
            <p className="community mb-5">Community : {Data?.cityRegion}</p>
            <Content>
              <div className="Info first o-bars">
                <h3>
                  {Data?.bedroomsTotal ?? 0}
                  &nbsp;
                  <svg
                    className="mb-1"
                    width="28"
                    height="19"
                    viewBox="0 0 28 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.75 2.75H15.75C14.0931 2.75 12.75 4.09315 12.75 5.75V8.5C12.75 10.1569 11.4069 11.5 9.75 11.5H5.75C4.09315 11.5 2.75 10.1569 2.75 8.5V1.5C2.75 0.809644 2.19036 0.25 1.5 0.25C0.809644 0.25 0.25 0.809644 0.25 1.5V17.75C0.25 18.4404 0.809644 19 1.5 19C2.19036 19 2.75 18.4404 2.75 17.75V17.125C2.75 16.0895 3.58947 15.25 4.625 15.25H23.375C24.4105 15.25 25.25 16.0895 25.25 17.125V17.75C25.25 18.4404 25.8096 19 26.5 19C27.1904 19 27.75 18.4404 27.75 17.75V7.75C27.75 6.42392 27.2232 5.15215 26.2855 4.21447C25.3478 3.27678 24.0761 2.75 22.75 2.75ZM7.75 10.25C8.74456 10.25 9.69839 9.85491 10.4016 9.15165C11.1049 8.44839 11.5 7.49456 11.5 6.5C11.5 5.50544 11.1049 4.55161 10.4016 3.84835C9.69839 3.14509 8.74456 2.75 7.75 2.75C6.75544 2.75 5.80161 3.14509 5.09835 3.84835C4.39509 4.55161 4 5.50544 4 6.5C4 7.49456 4.39509 8.44839 5.09835 9.15165C5.80161 9.85491 6.75544 10.25 7.75 10.25Z"
                      fill="#2C3647"
                    />
                  </svg>
                </h3>
                <p>Bedroom</p>
              </div>

              <div className="Info ">
                <h3>
                  {Data?.bathroomsTotal ?? 0}
                  &nbsp;
                  <svg
                    className="mb-1"
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.875 15.5C24.5298 15.5 24.25 15.7798 24.25 16.125V16.75C24.25 18.858 23.2073 20.7224 21.6037 21.8528C21.228 22.1176 21.0161 22.5757 21.128 23.0215L21.4379 24.2566C21.5964 24.888 21.119 25.5 20.468 25.5H20.0308C19.5719 25.5 19.1719 25.1877 19.0606 24.7425L18.8144 23.7575C18.7031 23.3123 18.3031 23 17.8442 23H8.15578C7.69691 23 7.29693 23.3123 7.18563 23.7575L6.93937 24.7425C6.82807 25.1877 6.42809 25.5 5.96922 25.5H5.53198C4.88103 25.5 4.4036 24.888 4.56205 24.2566L4.87183 23.0222C4.98381 22.576 4.77154 22.1178 4.39536 21.853C3.68775 21.3548 3.08916 20.713 2.64049 19.9664C2.05685 18.9951 1.74898 17.8831 1.75 16.75V16.125C1.75 15.7798 1.47018 15.5 1.125 15.5C0.779822 15.5 0.5 15.2202 0.5 14.875V14C0.5 13.4477 0.947715 13 1.5 13H22C22.5523 13 23 12.5523 23 12V4.25C23 3.91848 22.8683 3.60054 22.6339 3.36612C22.3995 3.1317 22.0815 3 21.75 3C21.3556 3 21.0209 3.16924 20.79 3.43548C20.5381 3.72585 20.6957 4.13914 20.9385 4.43712C21.2529 4.82283 21.4847 5.27331 21.6182 5.76168C21.7639 6.2944 21.3023 6.75 20.75 6.75H15.25C14.6977 6.75 14.237 6.29454 14.3825 5.76178C14.5529 5.13817 14.8832 4.56346 15.3483 4.09835C16.0516 3.39509 17.0054 3 18 3C18.1274 3 18.2398 2.91917 18.289 2.80173C18.8537 1.45526 20.1881 0.5 21.75 0.5C22.7446 0.5 23.6984 0.895088 24.4017 1.59835C25.1049 2.30161 25.5 3.25544 25.5 4.25V14.875C25.5 15.2202 25.2202 15.5 24.875 15.5Z"
                      fill="#2C3647"
                    />
                  </svg>
                </h3>
                <p>Bathroom</p>
              </div>
              <div className="Info  d-bars">
                <h3>
                  {Data?.garageSpaces ?? 0}
                  &nbsp;
                  <svg
                    className="mb-1"
                    width="20"
                    height="20"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.75 18C17.75 18.5523 17.3023 19 16.75 19H16.25C15.6977 19 15.25 18.5523 15.25 18V8.75C15.25 8.19772 14.8023 7.75 14.25 7.75H3.75C3.19772 7.75 2.75 8.19772 2.75 8.75V18C2.75 18.5523 2.30228 19 1.75 19H1.25C0.697715 19 0.25 18.5523 0.25 18V5.83032C0.25 5.47147 0.442286 5.14012 0.753861 4.96208L8.50386 0.533508C8.81129 0.357832 9.18871 0.357832 9.49614 0.533508L17.2461 4.96208C17.5577 5.14012 17.75 5.47147 17.75 5.83032V18ZM4 10C4 9.44771 4.44772 9 5 9H13C13.5523 9 14 9.44771 14 10V10.5C14 11.0523 13.5523 11.5 13 11.5H5C4.44772 11.5 4 11.0523 4 10.5V10ZM4 13.75C4 13.1977 4.44772 12.75 5 12.75H13C13.5523 12.75 14 13.1977 14 13.75V14.25C14 14.8023 13.5523 15.25 13 15.25H5C4.44772 15.25 4 14.8023 4 14.25V13.75ZM13 16.5C13.5523 16.5 14 16.9477 14 17.5V18C14 18.5523 13.5523 19 13 19H5C4.44772 19 4 18.5523 4 18V17.5C4 16.9477 4.44772 16.5 5 16.5H13Z"
                      fill="#2C3647"
                    />
                  </svg>
                </h3>
                <p>Garage</p>
              </div>
              <div className="Info o-bars">
                {type === "sold" ? (
                  <>
                    <h3>
                      {JSON.parse(Data?.property_details)?.square_footage ===
                        "" ||
                        !JSON.parse(Data?.property_details)?.square_footage
                        ? "No Data"
                        : !JSON.parse(Data?.property_details)?.square_footage}
                      &nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mb-1"
                        width="20"
                        height="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z" />
                      </svg>
                    </h3>
                    <p>Square Feet</p>
                  </>
                ) : (
                  <>
                    <h3>
                      {Data?.livingAreaRange || "No Data"}
                      &nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mb-1"
                        width="20"
                        height="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z" />
                      </svg>
                    </h3>
                    <p>Square Feet</p>
                  </>
                )}
              </div>
              <div className="Info Price">
                <h1>
                  $
                  {type !== "sold"
                    ? ConvertToCanadianNumber(Data?.listPrice)
                    : ConvertToCanadianNumber(Data?.sold_price)}
                </h1>
                {type === "sold" && (
                  <p>
                    Listed For{" "}
                    {ConvertToCanadianNumber(
                      JSON.parse(Data?.property_details)?.["Lp_dol"],
                    )}
                  </p>
                )}
              </div>
            </Content>
            <Contact>
              <div className="row">
                <div className="col-12 col-sm-5 meadia-img">
                  <img
                    src={`/public/${profile.image}`}
                    alt="Agent Image"
                  />
                </div>
                <div className="col-12 col-sm-7 p-5">
                  <div className="row mb-3">
                    <div className="col-12">
                      <h2 className="mb-5">CONTACT AGENT</h2>
                      <h4 className="m-0">{profile.name || "Mr.Realtor"}</h4>
                      <h6 className="m-0">{profile.brokeragename || "Mr.Realtor"}</h6>
                      <small>
                        {profile.description || "Lorem, ipsum dolor sit amet"}
                      </small>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 d-flex justify-content-start pt-3">
                      <i className="pe-3 pt-1">
                        <svg
                          width="30"
                          height="25"
                          viewBox="0 0 30 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.7964 8.1207H19.2036V8.7279C19.2036 10.8195 20.9082 12.5259 23.001 12.5259H24.741L25.2852 20.7051C25.3776 22.1235 24.2868 23.2719 22.8822 23.2719H7.0032C5.5944 23.2719 4.5084 22.1085 4.6002 20.7039C4.782 17.9895 4.9152 15.2313 5.154 12.5265H6.9996C9.0918 12.5265 10.797 10.8207 10.797 8.7285V8.1207H10.7964ZM11.46 16.5807C11.46 14.6565 13.0188 13.0977 14.943 13.0977C16.8666 13.0977 18.4254 14.6571 18.4254 16.5807C18.4254 18.5055 16.8678 20.0631 14.943 20.0631C13.02 20.0637 11.46 18.5043 11.46 16.5807ZM14.943 12.0381C12.4344 12.0381 10.4004 14.0721 10.4004 16.5807C10.4004 19.0887 12.435 21.1233 14.943 21.1233C17.4486 21.1233 19.485 19.0869 19.485 16.5807C19.485 14.0727 17.451 12.0381 14.943 12.0381ZM9.0846 4.8363C8.22 4.8363 7.512 5.5443 7.512 6.4089V8.7285C7.512 9.0093 7.2804 9.2415 6.999 9.2415H1.5726C1.2906 9.2415 1.0596 9.0111 1.0596 8.7285V6.9285C1.0596 6.4797 1.1628 6.0945 1.3902 5.7069C1.896 4.8465 2.7294 4.1013 3.795 3.4749C9.279 0.2517 20.7192 0.2523 26.2044 3.4749C27.2706 4.1013 28.104 4.8465 28.6098 5.7069C28.8354 6.0921 28.9398 6.4815 28.9398 6.9285V8.7285C28.9398 9.0111 28.71 9.2415 28.4268 9.2415H23.0004C22.719 9.2415 22.4874 9.0093 22.4874 8.7285V6.4089C22.4874 5.5425 21.7806 4.8363 20.9148 4.8363H9.0846ZM8.571 6.4089C8.571 6.1263 8.8026 5.8965 9.0846 5.8965H20.9154C21.1968 5.8965 21.429 6.1275 21.429 6.4089V8.7285C21.429 9.5943 22.1352 10.3017 23.001 10.3017H28.4274C29.292 10.3017 30 9.5931 30 8.7285V6.9285C30 6.2835 29.8464 5.7291 29.5206 5.1729C28.9188 4.1493 27.9564 3.2799 26.7384 2.5641C20.9214 -0.8547 9.0798 -0.8547 3.2622 2.5641C2.0436 3.2799 1.0812 4.1487 0.48 5.1729C0.153 5.7291 0 6.2835 0 6.9279V8.7279C0 9.5925 0.7092 10.3011 1.5726 10.3011H6.999C7.8648 10.3011 8.571 9.5937 8.571 8.7279V6.4089ZM9.7368 7.5915V8.7285C9.7368 10.2387 8.5092 11.4669 6.999 11.4669H4.6686C4.3914 11.4669 4.164 11.6799 4.1412 11.9511C3.8892 14.8347 3.7386 17.7435 3.5448 20.6331C3.4116 22.6425 4.989 24.3315 7.0032 24.3315H22.8822C24.882 24.3315 26.475 22.6575 26.3406 20.6343L25.7622 11.9607C25.7436 11.6811 25.5102 11.4675 25.2342 11.4675L23.001 11.4663C21.4902 11.4663 20.2632 10.2375 20.2632 8.7279V7.5909C20.2632 7.2981 20.0262 7.0611 19.7334 7.0611H10.2666C9.9738 7.0611 9.7368 7.2987 9.7368 7.5915Z"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </i>
                      <span>
                        <p className="text-title">Phone number</p>
                        <a href="tel:0000000000" className="hyperlink-style-2">
                          {profile.phone || "phone Number"}
                        </a>
                      </span>
                    </div>

                    <div className="col-12 col-md-6 d-flex justify-content-start pt-3">
                      <i className="pe-3 pt-1">
                        <svg
                          width="30"
                          height="19"
                          viewBox="0 0 30 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 0C0.903517 0 0 0.903517 0 2V16.6667C0 17.7631 0.903517 18.6667 2 18.6667H28C29.0965 18.6667 30 17.7631 30 16.6667V2C30 0.903517 29.0965 0 28 0H2ZM2.4375 1.33333H27.5625L15.6458 11.4896C15.3389 11.7512 14.6612 11.7512 14.3542 11.4896L2.4375 1.33333ZM1.33333 2.13542L10.1979 9.6979L1.33333 16.5729V2.13542ZM28.6667 2.13542V16.5729L19.8021 9.6979L28.6667 2.13542ZM11.2396 10.5833L13.4896 12.5C14.3543 13.2369 15.6457 13.2369 16.5104 12.5L18.7604 10.5833L27.4687 17.3333H2.53125L11.2396 10.5833Z"
                            fill="#ffffff"
                          ></path>
                        </svg>
                      </i>
                      <span>
                        <p className="text-title">E-Mail</p>
                        <a
                          href={`mailto:${profile.email}?`}
                          className="hyperlink-style-2"
                        >
                          {profile.email || " hello@redbuyers.com"}
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 d-flex justify-content-start pt-4">
                      <button
                        className="btn btn-outline-dark"
                        style={{ color: "#fff", borderColor: "#fff" }}
                        onClick={() => setAppointment((prev) => !prev)}
                      >
                        Contact agent
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Contact>
            <NavContainer className="container">
              <a href="#Overview">Overview</a>
              <a href="#Map">Map</a>
              <a href="#Property_Details">Property Details</a>
              <a href="#Virtual_Tour">Virtual Tour</a>
              <a href="#Floor_plan">Floor plan</a>
            </NavContainer>

            {/* Details  */}
            <Details Data={Data} />

            {/* <ImageViewer Images={Data?.photos} /> */}
            {/* <FeaturedContainer>
          <h1>Nearby Developments</h1>
          <div className="FeaturedContainer">
            {Data?.developments.length !== 0 ? (
              <>
                <Slider
                  {...FeaturedCard}
                  ref={FeaturedslideRef}>
                  {Data?.developments?.map((data) => (
                    <div
                      className="Cards"
                      key={data.id}>
                      <PropertyCard
                        key={data.id}
                        Data={data}
                      />
                    </div>
                  ))}
                </Slider>
                <CustomBar
                  totalSlides={Data?.developments?.length}
                  currentSlide={currentSlide}
                />
              </>
            ) : (
              <ErrorScreen
                message={'We dont have nearby development property'}
              />
            )}
          </div>
        </FeaturedContainer> */}
            {type !== "sold" && soldProperty?.length > 0 && (
              <ComparableHomes>
                <h3>Comparable Homes</h3>
                <div className="container">
                  {soldProperty?.map((card) => (
                    //     <PropertyCard
                    //       propertyCardType={cardType}
                    //       propertyType={"sold"}
                    //       propertyData={card}
                    //       key={card.id}
                    //     />
                    //   ))}
                    <SoldProperty PropertyData={card} user={user} handleNavigation={handleNavigation} />))}
                </div>
              </ComparableHomes>
            )}
            {type !== "sold" && similarProperty?.length > 0 && (
              <ComparableHomes>
                <h3 className="cusfont">Similar Homes</h3>
                <Slider
                  infinite={similarProperty.length >= 4}
                  speed={500}
                  slidesToShow={Math.min(4, similarProperty.length)}
                  slidesToScroll={1}
                  autoplay={true}
                  autoplaySpeed={3000}
                  responsive={[
                    { breakpoint: 1200, settings: { slidesToShow: Math.min(3, similarProperty.length) } },
                    { breakpoint: 900, settings: { slidesToShow: Math.min(2, similarProperty.length) } },
                    { breakpoint: 600, settings: { slidesToShow: 1 } },
                  ]}
                >
                  {similarProperty.map((card) => (
                    <div key={card.id} style={{ padding: "0 0.5rem" }}>
                      <PropertyCard1 PropertyData={card} />
                    </div>
                  ))}
                </Slider>
              </ComparableHomes>
            )}
            {type === "sold" && similarProperty?.length > 0 && (
              <ComparableHomes>
                <h3 className="cusfont">Similar Homes</h3>
                <div className="container">
                  {similarProperty.map((card) => (
                    <SoldProperty key={card.id} PropertyData={card} user={user} handleNavigation={handleNavigation} />
                  ))}
                </div>
              </ComparableHomes>
            )}
          </Container>
        </div>
      )}
      {appointment && (
        <AppointmentContainer onClick={() => setAppointment((prev) => !prev)}>
          <AppointmentForm Data={Data} />
        </AppointmentContainer>
      )}
      {open && (
        <SoldHomeForm handleOpenClose={handleOpenClose} handleState={handleState} handleSubmitForm={handleSubmitForm} />
      )
      }

    </>
  );
}
